<template lang="pug">
  div
    div
    el-row
      el-col
        h3.title Ventas - {{ selectedCountryName }}
    el-row
      el-col
        el-form(:inline="true" label-position="top" size="mini")
          el-form-item(label="País:")
            select-input(:options="countries" :attribute="search" modelKey="country")
          el-form-item(label="Operadores:")
            select-input(
              :options="filteredConciliables"
              :attribute="search"
              modelKey="operators"
              :multiple="true"
            )
          el-form-item(label="Entre los meses:")
            date-input(:inputModel="search" modelKey="monthRange" type="monthrange")
          el-form-item.filters__buttons-wrapper
            el-button(
              type="primary"
              icon="el-icon-search"
              @click="fetchSales()"
            ) FILTRAR
            el-button(
              v-if="canSeeButton()"
              type="success"
              icon="el-icon-download"
              @click.prevent="exportSales()"
            ) EXPORTAR
    el-row
      el-col
        data-table(
          :headers="headers"
          :items="items"
          :shownActions="false"
          @cellClickEvent="handleCellClick"
          :height="500"
          :loading="loading"
          refTable="masterSalesTable"
          :stripe="false"
        )
    el-row
      el-col
        h5 Venta Estimada {{ currentMonth }}
        p {{ estimatedSales }}
</template>

<script>
import SelectInput from '@/components/forms/inputs/SelectInput.vue';
import DataTable from '@/components/tables/DataTable.vue';
import DateInput from '@/components/forms/inputs/DateInput.vue';

// eslint-disable-next-line import/no-cycle
import FinanceApi from '@/services/apiService';
import DataService from '@/services/dataService';
import DateService from '@/services/dateService';
import store from '@/store';
import permissions from '@/constants/permissions';

// eslint-disable-next-line import/no-cycle
import conciliables from '@/mixins/conciliables';

import handleDownload from '@/utils/handleDownload';
import { currencyFormatter } from '@/utils/cellFormatter';

export default {
  name: 'Sales',
  components: {
    SelectInput, DataTable, DateInput,
  },
  mixins: [
    conciliables,
  ],
  data() {
    return {
      columns: [],
      items: [],
      search: {
        country: 'CL',
        operators: [],
        monthRange: [
          DateService.getDate(),
          DateService.getDate(),
        ],
      },
      estimatedSales: 0,
      selectedCountry: null,
      loading: false,
    };
  },
  beforeMount() {
    this.fetchSales();
  },
  methods: {
    fetchSales() {
      this.loading = true;
      FinanceApi.get_master_sales(this.search, false).then((data) => {
        const items = data.body.data.map((item) => {
          this._.forEach(item, (value, key) => {
            if (key !== 'operator') {
              // eslint-disable-next-line no-param-reassign
              item[key] = {
                ...value, type: 'currency', click: true, cellClass: 'data-table__click-row',
              };
            }
          });
          return item;
        });
        const summaries = data.body.summaries.map((summary, index) => {
          const newSummary = { rowClass: 'data-table__summary-row' };
          const type = this.getSummaryType(index);
          summary.forEach((item) => {
            if (item.key === 'operator') {
              newSummary[item.key] = item.value;
            } else {
              newSummary[item.key] = { value: item.value, type };
            }
          });
          return newSummary;
        });
        this.items = [...items, ...summaries];
        this.columns = data.body.columns;
        this.estimatedSales = currencyFormatter(data.body.estimated_sales, this.search.country);
        this.loading = false;
      }).catch((exception) => {
        this.$notify.error({ title: 'Error', message: exception.body.message });
      });
      this.selectedCountry = this.search.country;
    },
    exportSales() {
      FinanceApi.get_master_sales(this.search, true).then((res) => {
        handleDownload(res);
      }).catch((exception) => {
        this.$notify.error({ title: 'Error', message: exception.body.message });
      });
    },
    handleCellClick({ column, row }) {
      const columnName = column.property;
      const { id, click } = row[columnName];

      if (click) {
        store.commit('selectTotal', id);
        this.$router.push({ name: 'conciliation', params: { id } });
      }
    },
    getSummaryType(index) {
      switch (index) {
        case 1:
          return 'currency';
        default:
          return null;
      }
    },
    canSeeButton() {
      const role = store.state.user.role || '';
      return permissions.FinanceGroup.includes(role);
    },
  },
  computed: {
    countries() {
      return DataService.get_countries();
    },
    selectedCountryName() {
      return this.countries.find((country) => country.key === this.selectedCountry).value;
    },
    headers() {
      return this.columns.map((column) => {
        if (column.key === 'operator') {
          return { ...column, fixed: true, className: 'data-table__fixed-column' };
        }

        return { ...column, type: 'object', country: this.search.country };
      });
    },
    currentMonth() {
      return DateService.getDate(null, 'MMMM YYYY');
    },
  },
};
</script>
